const GOOGLE_ADS_ID = 'AW-18458026226'

// Labels come from each Google Ads conversion action's event snippet.
// An account ID alone is not a conversion destination.
const CONVERSION_LABELS = {
  // Google Ads action: AffiliateOutboundClick; Meta keeps its existing event name.
  AffiliateOutboundVisit: process.env.REACT_APP_GOOGLE_ADS_AFFILIATE_OUTBOUND_LABEL ?? 'l6URCNPMyoEdEPLBvOFE',
  AffiliateClick: process.env.REACT_APP_GOOGLE_ADS_AFFILIATE_CLICK_LABEL,
  OpenCase: process.env.REACT_APP_GOOGLE_ADS_OPEN_CASE_LABEL,
  SocialLinkClick: process.env.REACT_APP_GOOGLE_ADS_SOCIAL_LINK_LABEL,
}

let initialized = false
let consentGranted = false

function consentState(value) {
  return {
    ad_storage: value,
    analytics_storage: value,
    ad_user_data: value,
    ad_personalization: value,
  }
}

export function setGoogleAdsConsent(granted) {
  consentGranted = granted === true

  // Basic consent mode: no Google script or requests until acceptance.
  if (!consentGranted && !initialized) return

  if (initialized) {
    window.gtag('consent', 'update', consentState(consentGranted ? 'granted' : 'denied'))
    return
  }

  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments) }
  window.gtag('consent', 'default', consentState('denied'))
  window.gtag('consent', 'update', consentState('granted'))
  window.gtag('js', new Date())
  // The initial view and React Router navigation are tracked explicitly.
  window.gtag('config', GOOGLE_ADS_ID, { send_page_view: false })
  initialized = true
  trackGoogleAdsPageView()

  if (!document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js"]')) {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`
    document.head.appendChild(script)
  }
}

export function trackGoogleAdsPageView(params = {}) {
  if (!initialized || !consentGranted) return

  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_title: document.title,
    ...params,
    send_to: GOOGLE_ADS_ID,
  })
}

export function trackGoogleAdsEvent(name, params = {}, { eventId } = {}) {
  if (!initialized || !consentGranted) return

  // Mirror Meta's interaction events; these alone are not Ads conversions.
  window.gtag('event', name, { ...params, send_to: GOOGLE_ADS_ID })

  const label = CONVERSION_LABELS[name]?.trim()
  if (!label) return

  window.gtag('event', 'conversion', {
    send_to: `${GOOGLE_ADS_ID}/${label}`,
    // Fixed value from the AffiliateOutboundClick event snippet, not revenue.
    ...(name === 'AffiliateOutboundVisit' ? { value: 1.0, currency: 'SEK' } : {}),
    ...(eventId ? { transaction_id: eventId } : {}),
  })
}
